export const PICK_UP_LOCATION_TAB_ID = 'pickUp' as const
export const DROP_OFF_LOCATION_TAB_ID = 'dropOff' as const

export type CarHireLocationTabId =
  | typeof PICK_UP_LOCATION_TAB_ID
  | typeof DROP_OFF_LOCATION_TAB_ID
